<div class="nav-container-separator"></div>
<mat-accordion class="mat-dialog-accordion">
    <mat-expansion-panel [expanded]="isexpanded">
        <mat-expansion-panel-header [expandedHeight]="'43px'" [collapsedHeight]="'43px'">
            <mat-panel-title id="accAccountCodeMaster">
                <div class="d-flex ">
                    <div class="d-flex align-items-center flex-grow-1">
                        <span class="fs-16 ff-2"> Message</span>
                    </div>
                    <div class="d-flex justify-content-end">
                        <div class="icons-container view-page-wrap-icons d-flex">
                            <i aria-hidden="true" class="eip-link" class="fa fa-paperclip fs-16 eip-mr-5" (click)="viewAttachmentClick()"></i>
                            <i title="Reply" class="fa fa-reply" *ngIf="canReply" (click)="$event.stopPropagation();respondMail('replyMail')" aria-hidden="true"></i>
                            <i title="Reply All" class="fa fa-repeat-o" *ngIf="canReply" (click)="$event.stopPropagation();respondMail('replyAllMail')" aria-hidden="true"></i>
                            <i title="Forward" class="fa fa-angle-double-right" *ngIf="canReply" (click)="$event.stopPropagation();respondMail('ForwardMail')" aria-hidden="true"></i>                            
                            <!-- <EIPDiscussionForum  class="d-inline-block" [discussionForumParameters]='discussionForumParameters'   (OnClick)='setParams()'></EIPDiscussionForum> -->
                            <!-- <i title="Print" class="fa fa-print"></i> -->
                            <i title="History" class="fa fa-history" (click)="$event.stopPropagation();viewHistoryLog()" aria-hidden="true"></i>
                            <i title="{{isallExpand?'Collapse':'Expand'}}" [ngClass]="isallExpand?'fa-collapse-all':'fa-expand-all'" aria-hidden="true" id="ibtINDVCollapseAll" (click)="isallExpand =!isallExpand"></i>
                        </div>
                    </div>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row reset-row mail-container">
            <div class="d-flex justify-content-between eip-mb-xs-10 flex-wrap flex-sm-nowrap align-items-center eip-pr-10">
                <div class="d-flex justify-content-center align-items-center eip-py-10">
                    <div class="avatar d-flex flex-column justify-content-center align-items-center eip-mr-10">
                        <img src="../../../../edmsui/assets/images/L&T.png" width="40" height="40" alt="" />
                    </div>
                    <div class="title-container">
                        <p class="date">{{sentOn}}</p>
                        <p class="title fs-16 ff-2">Larsen & Toubro LTD</p>
                        <p class="subject fs-12">Sub: {{messageSubject}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row reset-row d-flex">
            <div class="title-container">
                <p class="subject fs-12">To: <span class="cc">{{to}}</span></p>
                <p class="subject fs-12">CC: <span class="cc">{{cc}}</span></p>
            </div>
        </div>
        <div class="row1 res1et-row mail-container">
            <div class="d-fle1x justify-content-between eip-mb-xs-10 flex-wrap flex-sm-nowrap align-items-center eip-pr-10">
                <div class="d-flex flex-row justify-content-center align-items-center eip-py-10" width="100%">
                    <div *ngIf="mailType=='RFI'">
                        <app-rfi-template [message]="message" [to]="to" [cc]="cc"></app-rfi-template>
                    </div>
                    <div *ngIf="mailType=='NCR'">
                        <app-mail-template-ncr [message]="message" [to]="to" [cc]="cc"></app-mail-template-ncr>
                    </div>
                    <div *ngIf="mailType!='RFI'&&mailType!='NCR'">
                        <app-mail-template [message]="message" [to]="to" [cc]="cc"></app-mail-template>
                    </div>
                    <!-- <div *ngIf="mailType=='Transmittal'">
            <app-mail-template-transmittal [message]="message" [to]="to" [cc]="cc"></app-mail-template-transmittal>
          </div> -->
                </div>
            </div>
        </div>
        <div class="row reset-row mail-container d-flex justify-content-end ">
            <div class="eip-mb-xs-10 align-items-end eip-pr-10">
                <div class="title-container text-center">
                    <div class="faith">Your Faithfully</div>
                    <div class="fs-14 ff-3">{{from[0]}}</div>
                    <div class="title fs-14 ff-3">{{from[1]}}</div>
                </div>
            </div>
        </div>
    </mat-expansion-panel>
</mat-accordion>